import { HttpClient, HttpErrorResponse, HttpXhrBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JwtHelperService } from "@auth0/angular-jwt";
import { LoginController } from 'app/controllers/login.controller';
import { environment } from 'environments/environment';
import { LocalStorageService } from './local-storage.service';
import { SessionStorageService } from './session-storage.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs/internal/observable/throwError';
import { DialogFactory } from 'utils/DialogFactory';

const jwtHelper = new JwtHelperService();
@Injectable({
    providedIn: 'root'
})
export class LoginService {
    private readonly _api = `${environment.protocol}://${environment.host}:${environment.port}/${environment.context}/${environment.apiroot}/login/access-token`;
    
    private _httpClient = new HttpClient(new HttpXhrBackend({ build: () => new XMLHttpRequest() }));

    constructor(
        private loginController: LoginController,
        private _sessionStorageService: SessionStorageService,
        private _localStorageService: LocalStorageService,
        private _dialogFactory: DialogFactory
    ) { }

    getTemporaryAccessToken() {
        return this._httpClient.get(this._api, { observe: "response" }).pipe(
            catchError((error: HttpErrorResponse) => {
                console.error(error.error.message);
                this._dialogFactory.snack(error.error.message, 'OK', DialogFactory.SNACK_WARNING, { duration: 3000 });
                return throwError(error);
            }))
            .subscribe(response => {
                this._localStorageService.setValue("token", response.headers.get("Authorization"));
            });
    }

    isValid():Boolean {
        return !jwtHelper.isTokenExpired(this._sessionStorageService.getValue('token'));
    }
}
